// Merge two PostTruckPrefill objects with truck values overriding global, missing fields
// falling back to global. Mirrors `StrategyService.mergeWith` on the backend so that the
// Adjust-strategy modal preview matches what will be applied after Save.
//
// Either argument may be null. If both are null, returns null.
export const mergePrefills = (truckPrefill, globalPrefill) => {
  if (!truckPrefill && !globalPrefill) return null;
  if (!truckPrefill) return globalPrefill;
  if (!globalPrefill) return truckPrefill;

  return {
    trailerType: truckPrefill.trailerType ?? globalPrefill.trailerType,
    outboundDistanceMin: truckPrefill.outboundDistanceMin ?? globalPrefill.outboundDistanceMin,
    outboundDistanceMax: truckPrefill.outboundDistanceMax ?? globalPrefill.outboundDistanceMax,
    minOffer: truckPrefill.minOffer ?? globalPrefill.minOffer,
    minRpm: truckPrefill.minRpm ?? globalPrefill.minRpm,
    pickupRadius: truckPrefill.pickupRadius ?? globalPrefill.pickupRadius,
    deliveryRadius: truckPrefill.deliveryRadius ?? globalPrefill.deliveryRadius,
    departureZip: truckPrefill.departureZip ?? globalPrefill.departureZip,
    destinationZip: truckPrefill.destinationZip ?? globalPrefill.destinationZip,
    preferredBrokers: truckPrefill.preferredBrokers ?? globalPrefill.preferredBrokers,
    avoidedBrokers: truckPrefill.avoidedBrokers ?? globalPrefill.avoidedBrokers,
    avoidedMarkets: truckPrefill.avoidedMarkets ?? globalPrefill.avoidedMarkets,
  };
};
